import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/patient-fields',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/PatientFieldsContainer',
      './modules/patientFields'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PatientFields = require('./containers/PatientFieldsContainer').default
      const actions = require('./modules/patientFields')
      const reducer = require('./modules/patientFields').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'patientFields', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, PatientFields)

    /* Webpack named bundle   */
    }, 'patientFields')
  }
})



// WEBPACK FOOTER //
// ./src/routes/PatientFields/index.js